import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.VUE_APP_SUPERCHART_MIXPANEL_TOKEN;

// URL에서 UTM 파라미터 추출 함수
const getUtmParameters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};

  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  utmKeys.forEach(key => {
    const value = urlParams.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });

  return utmParams;
};

// 공통 속성들을 가져오는 함수
const getCommonProperties = async () => {
  const commonProps = {
    // 기본 디바이스/브라우저 정보
    user_agent: navigator.userAgent,
    clientAccessTime: new Date().toISOString(),
    service: 'superchart',
  };

  // UTM 파라미터 추가 (값이 있는 경우만)
  const utmParams = getUtmParameters();
  Object.assign(commonProps, utmParams);

  // IP 정보 가져오기 (비동기)
  try {
    const response = await fetch('https://ipapi.co/json/');
    const ipData = await response.json();

    commonProps.ip = ipData.ip;
  } catch (error) {
    console.warn('IP 정보를 가져올 수 없습니다:', error);
  }

  return commonProps;
};

const initMixpanel = async () => {
  if (!MIXPANEL_TOKEN) return;

  try {
    mixpanel.init(MIXPANEL_TOKEN, { debug: true, persistence: 'localStorage' });
  } catch (error) {
    console.error('Mixpanel 초기화 실패:', error);
  }
};

initMixpanel();

// 확장된 Mixpanel 래퍼
const MixpanelWrapper = {
  // 공통 속성과 함께 이벤트 추적
  async trackSuperchartEvent(eventName, properties = {}) {
    if (!MIXPANEL_TOKEN || !mixpanel) return;

    try {
      const commonProps = await getCommonProperties();
      const mergedProps = { ...commonProps, ...properties, service: 'superchart' };

      console.log(eventName, mergedProps);

      mixpanel.track(eventName, mergedProps);
    } catch (error) {
      console.error('Mixpanel 이벤트 추적 실패:', error);
    }
  },

  get mixpanel() {
    return MIXPANEL_TOKEN ? mixpanel : null;
  },
};

// GTM에서 접근할 수 있도록 전역 객체로 노출
window.mixpanel = MixpanelWrapper;

export default {
  install(Vue) {
    Vue.prototype.$mixpanel = MixpanelWrapper;
  },
};
